module.exports = __webpack_public_path__ + "newsletter/Components/PocketHitsSignup/images/publishers/logo-theAtlantic.65bb19d13836abe553e25030f144cb03.png";